import { BlockItem } from 'pages/approvals/modals/ApprovalItems/BlockItem';
import { PublicationItem } from 'pages/approvals/modals/ApprovalItems/PublicationItem';

/**
 * @param {import('models/approval.models').ApprovalItem} approvalItem
 * @param {import('models/approval.models').ApprovalSnapshot} [snapshot]
 */
export function ApprovalItemType({ approvalItem, snapshot }) {
    if (approvalItem.target.type === 'publication') {
        return <PublicationItem approvalItem={approvalItem} />;
    }

    if (approvalItem.target.type === 'block') {
        return <BlockItem approvalItem={approvalItem} snapshot={snapshot} />;
    }

    return null;
}
